module.exports = require("@nestjs/passport");